// tog‘a #2065 W1 (2026-09-15): skan qabul qiladigan ochiq formalar reestri.
// Skanni ENG USTKI ko‘rinadigan qatlamdagi forma oladi (loyihada z-index 1000–1060 turli qiymatlar — konstanta emas, DOM dagi haqiqiy qiymat).
// Eng ustki ochiq oyna nishon bo‘lmasa (masalan, tanlash drawer’i) — skan pastdagi formaga TUSHMAYDI.
// Avvalgi `pendingScan` (har forma faylida modul darajasida, 4 s oyna) o‘rnini egallaydi: ko‘rinmas forma nusxasi skan olmaydi.
import type { ScanHit } from "./scanTypes"

export type ScanKind = "sale" | "purchase" | "order" | "showcase" | "returnSale" | "returnPurchase" | "transfer" | "pos" | "inventory"   // tog'a #4743: inventarizatsiya sanash varag'i

export interface ScanTarget {
  id: number
  kind: ScanKind
  getEl: () => HTMLElement | null
  getWarehouseId?: () => number | undefined
  /** true — bir nechta partiya bo‘lsa tanlash so‘raladi (Продажа) */
  needBatch?: boolean
  onScan: (hit: ScanHit) => void
}

const targets: ScanTarget[] = []
let seq = 0

function visible(el: HTMLElement | null): boolean {
  if (!el || !el.isConnected) return false
  if (el.getClientRects().length === 0) return false
  const drawer = el.closest(".ant-drawer") as HTMLElement | null
  if (drawer && !drawer.classList.contains("ant-drawer-open")) return false
  const wrap = el.closest(".ant-modal-wrap") as HTMLElement | null
  if (wrap && getComputedStyle(wrap).display === "none") return false
  return true
}

function layerZ(el: HTMLElement): number {
  let z = 0
  let n: HTMLElement | null = el
  while (n && n !== document.body) {
    const cs = getComputedStyle(n)
    if (cs.position !== "static") {
      const v = parseInt(cs.zIndex, 10)
      if (!isNaN(v)) z = Math.max(z, v)
    }
    n = n.parentElement
  }
  return z
}

/** ochiq modal/drawer qatlamlarining eng kattasi (ichida nishon bo‘lmasa ham) */
function topOverlayZ(): number {
  let z = 0
  document.querySelectorAll<HTMLElement>(".ant-modal-wrap, .ant-drawer.ant-drawer-open").forEach((w) => {
    const cs = getComputedStyle(w)
    if (cs.display === "none" || w.getClientRects().length === 0) return
    const v = parseInt(cs.zIndex, 10)
    if (!isNaN(v)) z = Math.max(z, v)
  })
  return z
}

export type PickResult = { target: ScanTarget } | { blockedBy: "overlay" } | null

export function pickScanTarget(): PickResult {
  const vis = targets.filter((t) => visible(t.getEl()))
  if (!vis.length) return topOverlayZ() > 0 ? { blockedBy: "overlay" } : null
  let best = vis[0]
  let bz = layerZ(vis[0].getEl() as HTMLElement)
  for (const t of vis.slice(1)) {
    const z = layerZ(t.getEl() as HTMLElement)
    if (z > bz || (z === bz && t.id > best.id)) {
      best = t
      bz = z
    }
  }
  // formadan ustunda boshqa ochiq oyna bor (tanlash drawer’i, tasdiq oynasi) — skan formaga tushmasin
  if (topOverlayZ() > bz) return { blockedBy: "overlay" }
  return { target: best }
}

export function hasVisibleTarget(kind: ScanKind): boolean {
  return targets.some((t) => t.kind === kind && visible(t.getEl()))
}

// ---- sarlavhadagi skaner oynasidan: «forma ochilsin va tovar qo‘shilsin» — forma ro‘yxatdan o‘tib ko‘ringach BIR MARTA yetkaziladi
let pending: { kind: ScanKind; hit: ScanHit; at: number } | null = null
let timer: ReturnType<typeof setInterval> | null = null

function flushPending(): boolean {
  if (!pending) return false
  if (Date.now() - pending.at > 8000) {
    pending = null
    return false
  }
  const p = pending
  const cands = targets.filter((t) => t.kind === p.kind && visible(t.getEl()))
  if (!cands.length) return false
  const best = cands.reduce((a, b) => (layerZ(b.getEl() as HTMLElement) >= layerZ(a.getEl() as HTMLElement) ? b : a))
  pending = null
  best.onScan(p.hit)
  return true
}

function flushSoon() {
  if (timer) return
  let n = 0
  timer = setInterval(() => {
    n++
    if (flushPending() || !pending || n > 40) {
      if (timer) clearInterval(timer)
      timer = null
    }
  }, 200)
}

export function queueScanFor(kind: ScanKind, hit: ScanHit) {
  pending = { kind, hit, at: Date.now() }
  flushSoon()
}

export function registerScanTarget(t: Omit<ScanTarget, "id">): () => void {
  const x: ScanTarget = { ...t, id: ++seq }
  targets.push(x)
  if (pending) flushSoon()
  return () => {
    const i = targets.indexOf(x)
    if (i >= 0) targets.splice(i, 1)
  }
}
